import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import sidebar from './modules/sidebar';
import settings from './modules/settings';
import forms from './modules/forms';
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
    modules: {
        auth,
        sidebar,
        settings,
        forms
    },
    strict: debug
})
